import {
  HIDE_MESSAGE,
  INIT_URL,
  ON_HIDE_LOADER,
  ON_SHOW_LOADER,
  SHOW_MESSAGE,
  SIGNIN_USER_SUCCESS,
  SIGNOUT_USER_SUCCESS,
  SIGNUP_USER_SUCCESS,
  ACTIVE_USER_SUCCESS,
  USER_FORGET_SUCCESS
} from "constants/ActionTypes";
import { CHANGE_PASSWORD_SUCCESS, CLEAR_TOKEN, SET_TOKEN, SIGNIN_EXTERNAL_USER_CALLBACK_SUCCESS, SIGNIN_EXTERNAL_USER_SUCCESS } from "../../constants/ActionTypes";

const INIT_STATE = {
  loader: false,
  alertMessage: '',
  showMessage: false,
  initURL: '',
  authUser: localStorage.getItem('user_id'),
  token: localStorage.getItem('token'),
  reToken: localStorage.getItem('reToken'),
  isActive: false,
  isReoveryFinished: false,
  callBackUrl: null
};


export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SIGNUP_USER_SUCCESS: {
      return {
        ...state,
        loader: false,
        authUser: action.payload
      }
    }
    case CLEAR_TOKEN: {
      return {
        ...state,
        token: null
      }
    }
    case ACTIVE_USER_SUCCESS: {
      return {
        ...state,
        loader: false,
        isActive: action.payload
      }
    }
    case SET_TOKEN: {
      return {
        ...state,
        loader: false,
        token: action.payload
      }
    }
    case SIGNIN_USER_SUCCESS: {
      return {
        ...state,
        loader: false,
        token: action.payload.at,
        reToken:action.payload.rt
      }
    }
   /*  case SIGNIN_USER_SUCCESS: {
      return {
        ...state,
        loader: false,
        token: action.payload
      }
    } */
    case SIGNIN_EXTERNAL_USER_SUCCESS: {
      return {
        ...state,
        loader: false,
        callBackUrl: action.payload
      }
    }
    case SIGNIN_EXTERNAL_USER_CALLBACK_SUCCESS: {
      return {
        ...state,
        loader: false,
        token: action.payload
      }
    }
    case CHANGE_PASSWORD_SUCCESS: {
      return {
        ...state,
        loader: false,
        isReoveryFinished: action.payload
      }
    }
    case USER_FORGET_SUCCESS: {
      return {
        ...state,
        loader: false,
        authUser: action.payload
      }
    }
    case INIT_URL: {
      return {
        ...state,
        initURL: action.payload
      }
    }
    case SIGNOUT_USER_SUCCESS: {
      return {
        ...state,
        authUser: null,
        initURL: '/',
        loader: false,
        token: null
      }
    }

    case SHOW_MESSAGE: {
      return {
        ...state,
        alertMessage: action.payload,
        showMessage: true,
        loader: false
      }
    }
    case HIDE_MESSAGE: {
      return {
        ...state,
        alertMessage: '',
        showMessage: false,
        loader: false
      }
    }

    case ON_SHOW_LOADER: {
      return {
        ...state,
        loader: true
      }
    }
    case ON_HIDE_LOADER: {
      return {
        ...state,
        loader: false
      }
    }
    default:
      return state;
  }
}
